import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../axios/axiosInstance";

const BASE = "/api/waba/automation";

// ── Basic Replies ──────────────────────────────────────
export const fetchBasicReplies = createAsyncThunk("wabaAutomation/fetchBasicReplies", async (_, { rejectWithValue }) => {
  try { return (await api.get(`${BASE}/basic-replies`)).data.data; }
  catch (e) { return rejectWithValue(e.response?.data?.message); }
});
export const createBasicReply = createAsyncThunk("wabaAutomation/createBasicReply", async (payload, { rejectWithValue }) => {
  try { return (await api.post(`${BASE}/basic-replies`, payload)).data.data; }
  catch (e) { return rejectWithValue(e.response?.data?.message); }
});
export const updateBasicReply = createAsyncThunk("wabaAutomation/updateBasicReply", async ({ id, ...payload }, { rejectWithValue }) => {
  try { return (await api.put(`${BASE}/basic-replies/${id}`, payload)).data.data; }
  catch (e) { return rejectWithValue(e.response?.data?.message); }
});
export const deleteBasicReply = createAsyncThunk("wabaAutomation/deleteBasicReply", async (id, { rejectWithValue }) => {
  try { await api.delete(`${BASE}/basic-replies/${id}`); return id; }
  catch (e) { return rejectWithValue(e.response?.data?.message); }
});
export const toggleBasicReply = createAsyncThunk("wabaAutomation/toggleBasicReply", async (id, { rejectWithValue }) => {
  try { return (await api.patch(`${BASE}/basic-replies/${id}/toggle`)).data.data; }
  catch (e) { return rejectWithValue(e.response?.data?.message); }
});

// ── Flows ──────────────────────────────────────────────
export const fetchFlows = createAsyncThunk("wabaAutomation/fetchFlows", async (_, { rejectWithValue }) => {
  try { return (await api.get(`${BASE}/flows`)).data.data; }
  catch (e) { return rejectWithValue(e.response?.data?.message); }
});
export const createFlow = createAsyncThunk("wabaAutomation/createFlow", async (payload, { rejectWithValue }) => {
  try { return (await api.post(`${BASE}/flows`, payload)).data.data; }
  catch (e) { return rejectWithValue(e.response?.data?.message); }
});
export const updateFlow = createAsyncThunk("wabaAutomation/updateFlow", async ({ id, ...payload }, { rejectWithValue }) => {
  try { return (await api.put(`${BASE}/flows/${id}`, payload)).data.data; }
  catch (e) { return rejectWithValue(e.response?.data?.message); }
});
export const deleteFlow = createAsyncThunk("wabaAutomation/deleteFlow", async (id, { rejectWithValue }) => {
  try { await api.delete(`${BASE}/flows/${id}`); return id; }
  catch (e) { return rejectWithValue(e.response?.data?.message); }
});
export const toggleFlow = createAsyncThunk("wabaAutomation/toggleFlow", async (id, { rejectWithValue }) => {
  try { return (await api.patch(`${BASE}/flows/${id}/toggle`)).data.data; }
  catch (e) { return rejectWithValue(e.response?.data?.message); }
});

const slice = createSlice({
  name: "wabaAutomation",
  initialState: {
    basicReplies: [],
    flows: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (b) => {
    const pending  = (s) => { s.loading = true; s.error = null; };
    const rejected = (s, a) => { s.loading = false; s.error = a.payload; };

    b.addCase(fetchBasicReplies.pending, pending)
     .addCase(fetchBasicReplies.fulfilled, (s, a) => { s.loading = false; s.basicReplies = a.payload; })
     .addCase(fetchBasicReplies.rejected, rejected)

     .addCase(createBasicReply.fulfilled, (s, a) => { s.basicReplies.unshift(a.payload); })
     .addCase(updateBasicReply.fulfilled, (s, a) => {
       const i = s.basicReplies.findIndex(r => r._id === a.payload._id);
       if (i !== -1) s.basicReplies[i] = a.payload;
     })
     .addCase(deleteBasicReply.fulfilled, (s, a) => { s.basicReplies = s.basicReplies.filter(r => r._id !== a.payload); })
     .addCase(toggleBasicReply.fulfilled, (s, a) => {
       const i = s.basicReplies.findIndex(r => r._id === a.payload._id);
       if (i !== -1) s.basicReplies[i] = a.payload;
     })

     .addCase(fetchFlows.pending, pending)
     .addCase(fetchFlows.fulfilled, (s, a) => { s.loading = false; s.flows = a.payload; })
     .addCase(fetchFlows.rejected, rejected)

     .addCase(createFlow.fulfilled, (s, a) => { s.flows.unshift(a.payload); })
     .addCase(updateFlow.fulfilled, (s, a) => {
       const i = s.flows.findIndex(f => f._id === a.payload._id);
       if (i !== -1) s.flows[i] = a.payload;
     })
     .addCase(deleteFlow.fulfilled, (s, a) => { s.flows = s.flows.filter(f => f._id !== a.payload); })
     .addCase(toggleFlow.fulfilled, (s, a) => {
       const i = s.flows.findIndex(f => f._id === a.payload._id);
       if (i !== -1) s.flows[i] = a.payload;
     });
  },
});

export default slice.reducer;
